export default __webpack_public_path__ + "static/media/landscape1.a79d17a0.jpg";